import React, { useState } from 'react';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';

type AnimationType = 'fade-in-up' | 'fade-in-right' | 'scale-in';
type DelayType = 0 | 100 | 200 | 300 | 400 | 500;

interface AnimatedSectionProps {
  children: React.ReactNode;
  className?: string;
  animation?: AnimationType;
  delay?: DelayType;
}

function AnimatedSection({
  children,
  className = '',
  animation = 'fade-in-up',
  delay = 0,
}: AnimatedSectionProps) {
  const [isVisible, setIsVisible] = useState(false);

  const ref = useIntersectionObserver({
    onIntersect: () => setIsVisible(true),
    threshold: 0.05,
    rootMargin: '0px 0px -30px 0px',
  });

  const classes = [
    className,
    'animated-section',
    isVisible ? 'is-visible' : '',
    animation === 'fade-in-right' ? 'reveal-right' : '',
    animation === 'scale-in' ? 'reveal-scale' : '',
  ].filter(Boolean).join(' ');

  return (
    <div
      ref={ref as React.RefObject<HTMLDivElement>}
      className={classes}
      style={{ '--animation-delay': `${delay}ms` } as React.CSSProperties}
    >
      {children}
    </div>
  );
}

export default AnimatedSection;
